import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Slider } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import PopperJs from 'popper.js';

interface RowItemProps {
  marks: Mark[];
  defaultValue: number;
  onChange(event: any, value: any): void;
}

export interface Mark {
  value: number;
  label: string;
}

const PrettoSlider = withStyles({
  root: {
    color: '#7675FC',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

interface Props {
  children: React.ReactElement;
  open: boolean;
  value: number;

}

const ValueLabelComponent = (props: Props) => {
  const { children, open, value } = props;
  const popperRef = React.useRef<PopperJs | null>(null);

  React.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });

  return (
    <Tooltip
      PopperProps={{
        popperRef,
      }}
      open={open}
      enterTouchDelay={0}
      placement="top"
      title={(value ? value : 0)}
    >
      {children}
    </Tooltip>
  );
}

const RateSlider: React.FC<RowItemProps> = (props) => {

  const valueLabelFormat = (value: number) => {
    const index = props.marks.findIndex(mark => mark.value === value);
    return `${value}%`;
  }

  const valuetext = (value: number) => {
    return `${value}%`;
  }

  let min = 0;
  let max = 10;

  if (props.marks.length) {
    min = props.marks[0].value;
    max = props.marks[props.marks.length-1].value;
  }

  return (
    <div>
      <PrettoSlider
        defaultValue={props.defaultValue}
        min={min}
        max={max}
        ValueLabelComponent={ValueLabelComponent}
        valueLabelFormat={valueLabelFormat}
        getAriaValueText={valuetext}
        aria-labelledby="discrete-slider-restrict"
        step={null}
        valueLabelDisplay="auto"
        marks={props.marks}
        onChange={props.onChange}
      />
    </div>
  )  
}
export default RateSlider;